import { Link } from "react-router";

export function Home() {
  return (
    <div style={{ padding: 16 }}>
      <h1 style={{ fontSize: 18, marginBottom: 12 }}>首页</h1>
      <Link to="/clothing">进入服装精选 →</Link>
    </div>
  );
}
